var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFuncionarios(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:gray;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H45V45H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M38.9,7.5H6.1A3.948,3.948,0,0,0,2,11.25v22.5A3.948,3.948,0,0,0,6.1,37.5H38.9A3.948,3.948,0,0,0,43,33.75V11.25A3.948,3.948,0,0,0,38.9,7.5Zm0,26.25H6.1V11.25H38.9ZM6.1,0H38.9V3.75H6.1Zm0,41.25H38.9V45H6.1ZM22.5,22.5a4.923,4.923,0,0,0,5.125-4.687A4.923,4.923,0,0,0,22.5,13.125a4.923,4.923,0,0,0-5.125,4.687A4.923,4.923,0,0,0,22.5,22.5Zm0-6.562a1.974,1.974,0,0,1,2.05,1.875,2.058,2.058,0,0,1-4.1,0A1.974,1.974,0,0,1,22.5,15.938ZM32.75,29.981c0-3.919-6.785-5.606-10.25-5.606s-10.25,1.688-10.25,5.606v1.894h20.5Zm-16.79-.919a12.377,12.377,0,0,1,13.1,0Z",
    transform: "translate(0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuncionarios);
export default __webpack_public_path__ + "static/media/funcionarios.82815016a108d48f7bb3a52eeb19a0f4.svg";
export { ForwardRef as ReactComponent };